var keyMirror = require('keymirror');

module.exports = keyMirror({
  SIGNUP_RESPONSE_RECEIVED: null,
  SIGNUP_ERROR: null
});